import React, { useState } from 'react';
import {
  buildUploadImageUrl,
  parseImageAltSource,
  resolveUploadRequestPath,
} from '../utils/extraInfoImages';
import './styles/QuestionImageUpload.css';

const ExtraInfoImage = ({ src, alt = 'Brainstorm scan' }) => {
  const [failed, setFailed] = useState(false);
  const { source, caption } = parseImageAltSource(alt);
  const path = resolveUploadRequestPath(src);
  const absoluteUrl = buildUploadImageUrl(src);

  if (!path || !path.includes('/api/uploads/') || !absoluteUrl) {
    return (
      <div className="extra-info-image-error">
        <p role="status">Invalid image link.</p>
      </div>
    );
  }

  if (failed) {
    return (
      <div className="extra-info-image-error">
        <p role="status">Could not load image in panel.</p>
        <a href={absoluteUrl} target="_blank" rel="noopener noreferrer">
          Open image in new tab
        </a>
      </div>
    );
  }

  return (
    <figure className="extra-info-image-figure">
      {source ? (
        <span
          className={`extra-info-image-source extra-info-image-source--${source}`}
        >
          {source === 'camera' ? 'Camera photo' : 'Uploaded file'}
        </span>
      ) : null}
      <img
        src={absoluteUrl}
        alt={caption || alt}
        className="extra-info-image"
        decoding="async"
        onLoad={(e) => e.currentTarget.classList.add('loaded')}
        onError={() => setFailed(true)}
      />
      {caption ? (
        <figcaption className="extra-info-image-caption">{caption}</figcaption>
      ) : null}
    </figure>
  );
};

export default ExtraInfoImage;
